<template>
  <RouterView />
</template>

<script setup lang="ts">
import axios from 'axios';
import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { useHead } from '@unhead/vue';
import {onMounted} from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

useHead({
  titleTemplate: (title?: string) => {
    const siteName = t('Models');
    return !title ? siteName : `${title} - ${siteName}`;
  },
});

const authStore = useAuthStore();

onMounted(() => {
  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    console.error(error);
    if (error.response.status === 401 || error.response.status === 419) {
      if (error.response.data.message === 'CSRF token mismatch.') return;
      authStore.logout()
          .catch((error) => { console.error(error); });
      router.replace({ name: 'login' });
    } else if (error.response.status === 403) {
      router.push({ name: 'verifyEmail' });
    } else if (error.response.status === 423) {
      router.push({ name: 'confirmPassword' });
    }

    return Promise.reject(error);
  });
});
</script>
